import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentListComponent } from './containers/document-list/document-list.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { PageTitle } from '@app/commons/utils/enums';
import { DocumentDetailComponent } from './containers/document-detail/document-detail.component';

const routes: Routes = [
  {
    path: 'documents',
    component: DocumentListComponent,
    canActivate: [AuthGuard],
    title: PageTitle.Documents,
  },
  {
    path: 'documents/:documentId',
    component: DocumentDetailComponent,
    canActivate: [AuthGuard],
    title: PageTitle.Documents,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentManagementRoutingModule { }
